import { CSSObject, Theme } from '@emotion/react';
import theme from './theme';
import { mobile } from './media';

const { color, radius } = theme;

const tableWrap: CSSObject = {
  maxHeight: 'max(280px, calc(100dvh - var(--table-offset, 330px)))',
  overflow: 'auto',
  overscrollBehavior: 'contain',
  WebkitOverflowScrolling: 'touch',
  marginTop: '16px',
  '> table > tbody': {
    '> tr:has(input[type="checkbox"]:checked)': {
      backgroundColor: color.grey75,
    },
    '> tr > td > label': {
      display: 'inline-block',
    },
  },
  '> table > thead > tr > td > label': {
    display: 'inline-block',
  },
  [mobile]: {
    maxHeight: 'none',
    margin: '12px -16px 0',
    padding: '0 16px',
  },
};

const tableToolbar: CSSObject = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  '> div, > form': {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 8,
  },
  [mobile]: {
    '> div, > form': {
      width: '100%',
    },
  },
};

const tableTop: CSSObject = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: 8,
  marginTop: 16,
  '> div': {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
  },
};

const detailWrap = (t: Theme): CSSObject => ({
  background: t.color.white,
  padding: '24px',
  borderRadius: radius.xl,
  userSelect: 'none',
  overflowX: 'auto',

  h3: {
    fontSize: 16,
    fontWeight: 700,
    color: t.color.text,

    '& ~ h3': {
      marginTop: 28,
      lineHeight: '22px',
    },

    span: {
      fontSize: '0.8rem',
      fontWeight: 400,
      color: t.color.textMuted,
    },
  },

  table: {
    width: '100%',
    minWidth: 800,
    marginTop: '12px',
    borderCollapse: 'separate',
    borderSpacing: 0,
    border: `1px solid ${t.color.grey100}`,
    borderRadius: radius.md,
    overflow: 'hidden',

    'td, th': {
      fontSize: 14,
      lineHeight: 1.45,
      padding: '14px 16px',
      textAlign: 'left',
      borderBottom: `1px solid ${t.color.grey75}`,
      fontWeight: 'normal',

      span: {
        position: 'relative',
        display: 'inline-block',
        marginRight: 24,
        color: t.color.grey,
        fontWeight: 400,

        '&::after': {
          content: '""',
          position: 'absolute',
          width: 1,
          height: 12,
          right: -12,
          borderRight: `solid 1px ${t.color.grey100}`,
        },
      },
    },

    'tr:last-of-type > td, tr:last-of-type > th': {
      borderBottom: 'none',
    },

    th: {
      width: 140,
      backgroundColor: t.color.grey50,
      color: t.color.grey600,
      fontWeight: 500,
    },
  },

  [mobile]: {
    padding: '20px 16px',
    borderRadius: radius.lg,
  },
});

export { tableWrap, tableToolbar, tableTop, detailWrap };
